import { NgModule } from '@angular/core';
import { NgxTooltip } from '@ngx-popovers/tooltip';
import { AST as HighchartsAST } from 'highcharts';
import { HighchartsChartComponent } from 'highcharts-angular';
import { MonacoEditorModule } from '../monaco-editor/monaco-editor.module';
import { AdvancedFilterComponent } from '../pivot-studio/components/visual-editor/filters/AdvancedFilter.component';
import { BasicFilterComponent } from '../pivot-studio/components/visual-editor/filters/BasicFilter.component';
import { DynamicFilterComponent } from '../pivot-studio/components/visual-editor/filters/DynamicFilter.component';
import { FilterEditorComponent } from '../pivot-studio/components/visual-editor/filters/FilterEditor.component';
import { RelativeDateOrTimeFilterComponent } from '../pivot-studio/components/visual-editor/filters/RelativeDateOrTime.component';
import { TopNFilterComponent } from '../pivot-studio/components/visual-editor/filters/TopNFilter.component';
import { VisualEditorFieldIconsComponent } from '../pivot-studio/components/visual-editor/layout/FieldIcons.component';
import { ContextMenuTriggerDirective } from '../polyfills/context-menu-trigger';
import { SharedModule } from '../shared/shared.module';
import { AIAgentChatComponent, AIAgentChatMessageComponent } from './ai/AIAgentChatComponent';
import { ContentSelectorDashboardPreviewComponent, ContentSelectorDialogComponent, ContentSelectorPreviewComponent, ContentSelectorVisualPreviewComponent } from './components/ContentSelector';
import { DashboardEmbedComponent } from './components/DashboardEmbed.component';
import { SidePanelComponent } from './components/SidePanel.component';
import { SidePanelFilterListComponent } from './components/SidePanelFilterList.component';
import { VisualEmbedComponent } from './components/VisualEmbed.component';
import { VisualEmbedDetailsComponent } from './components/VisualEmbedDetails.component';
import { TrgDragDirective, TrgDragHandleDirective } from './utils/TrgDrag.directive';
import { TrgDragDropService } from './utils/TrgDragDrop';
import { TrgDropDirective } from './utils/TrgDrop.directive';
import { VisualHostComponent } from './visuals/VisualHost.component';
import { VisualShellComponent } from './visuals/VisualShell.component';
import { PbirAgGridModule } from './visuals/agGrid/module';
import { AgGridPivotTableStyleEditorComponent, AgGridTableStyleEditorComponent } from './visuals/agGrid/styleEditor/TableStyleEditorComponent';
import { ExprEditorComponent } from './visuals/base/ExprEditor.component';
import { ExprEditorItemFilterComponent } from './visuals/base/ExprEditorItemFilter.component';
import { ExprFieldComponent } from './visuals/base/ExprField.component';
import { TextElementStyleEditorComponent } from './visuals/base/TextElementStyleEditor.component';
import { VisualEditorBoxComponent } from './visuals/base/VisualEditorBox.component';
import { VisualStyleEditorComponent } from './visuals/base/VisualStyleEditor.component';
import { CardStyleEditorComponent } from './visuals/card/CardStyleEditor.component';
import { CardVisualComponent } from './visuals/card/CardVisual.component';
import { VisualContentErrorDisplay } from './visuals/contentError/VisualContentErrorDisplay.component';
import { ErrorVisualComponent } from './visuals/error/ErrorVisual.component';
import { AreaChartVisualComponent, AreaChartVisualStyleEditorComponent } from './visuals/highcharts/AreaChartVisual.component';
import { BarChartVisualComponent } from './visuals/highcharts/BarChartVisual.component';
import { ChartStyleEditorComponent } from './visuals/highcharts/ChartVisualStyleEditor.component';
import { LineChartVisualComponent } from './visuals/highcharts/LineChartVisual.component';
import { PieChartVisualComponent } from './visuals/highcharts/PieChartVisual.component';
import { TreemapVisualComponent } from './visuals/highcharts/TreemapVisual.component';
import { WaterfallChartVisualComponent } from './visuals/highcharts/WaterfallChartVisual.component';
import { PbirHighchartsChartComponent } from './visuals/highcharts/base/PbirHighchartsChart.component';
import { VisualPlaceholderComponent } from './visuals/placeholder/VisualPlaceholder.component';
import { DataTooltipComponent } from './visuals/tooltip/DataTooltipComponent';
import { QueryPlanViewComponent } from './components/QueryPlanViewComponent';

HighchartsAST.bypassHTMLFiltering = true;

@NgModule({
  imports: [
    SharedModule,
    MonacoEditorModule,
    VisualEditorFieldIconsComponent,

    HighchartsChartComponent,
    PbirAgGridModule,

    FilterEditorComponent,
    AdvancedFilterComponent,
    BasicFilterComponent,
    DynamicFilterComponent,
    RelativeDateOrTimeFilterComponent,
    TopNFilterComponent,

    ContextMenuTriggerDirective,
    NgxTooltip,
  ],
  declarations: [
    TrgDragDirective,
    TrgDragHandleDirective,
    TrgDropDirective,
    
    ExprFieldComponent,
    ExprEditorComponent,
    ExprEditorItemFilterComponent,

    VisualHostComponent,
    VisualShellComponent,
    VisualStyleEditorComponent,
    VisualEditorBoxComponent,
    TextElementStyleEditorComponent, 

    ErrorVisualComponent,

    CardVisualComponent,
    CardStyleEditorComponent,

    PbirHighchartsChartComponent,
    ChartStyleEditorComponent,

    BarChartVisualComponent,
    LineChartVisualComponent,
    AreaChartVisualComponent,
    AreaChartVisualStyleEditorComponent,
    PieChartVisualComponent,
    TreemapVisualComponent,
    WaterfallChartVisualComponent,

    VisualEmbedComponent,
    VisualEmbedDetailsComponent,
    DashboardEmbedComponent,

    SidePanelComponent,
    SidePanelFilterListComponent,

    VisualPlaceholderComponent,

    ContentSelectorDialogComponent,
    ContentSelectorPreviewComponent, 
    ContentSelectorDashboardPreviewComponent, 
    ContentSelectorVisualPreviewComponent,

    AgGridTableStyleEditorComponent,
    AgGridPivotTableStyleEditorComponent,

    VisualContentErrorDisplay,

    AIAgentChatComponent,
    AIAgentChatMessageComponent,

    DataTooltipComponent,

    QueryPlanViewComponent
  ],
  exports: [
    TrgDragDirective,
    TrgDragHandleDirective,
    TrgDropDirective,

    ExprFieldComponent,
    ExprEditorComponent,

    VisualHostComponent,
    VisualShellComponent,
    VisualStyleEditorComponent,
    VisualEditorBoxComponent,
    
    VisualEmbedComponent,
    VisualEmbedDetailsComponent,
    DashboardEmbedComponent,

    SidePanelComponent,
    SidePanelFilterListComponent,

    ContentSelectorDialogComponent,
    ContentSelectorPreviewComponent, 
    ContentSelectorDashboardPreviewComponent, 
    ContentSelectorVisualPreviewComponent,

    VisualPlaceholderComponent,
    AIAgentChatComponent,
    
    QueryPlanViewComponent
  ],
  providers: [
    TrgDragDropService,
  ]
})
export class PbirModule { }
